import {Base} from "@/api/Base"

export class AdvisorOverrideEdit extends Base {
    path = "advisorOverride/edit"
}